export { default } from './FooterComponent';
